"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.reset = exports.initializeForm = exports.destroy = exports.changeSyncError = exports.change = void 0;
var _FormTypes = require("../actions/types/FormTypes");
const initializeForm = (formName, data) => dispatch => {
  dispatch({
    type: _FormTypes.INITIALIZE_FORM,
    payload: {
      formName,
      data
    }
  });
};
exports.initializeForm = initializeForm;
const change = (formName, field, data) => dispatch => {
  dispatch({
    type: _FormTypes.CHANGE_VALUE,
    payload: {
      formName,
      field,
      data
    }
  });
};
exports.change = change;
const reset = (formName, data) => dispatch => {
  dispatch({
    type: _FormTypes.RESET_FORM,
    payload: {
      formName,
      data
    }
  });
};
exports.reset = reset;
const destroy = formName => dispatch => {
  dispatch({
    type: _FormTypes.DELETE_FORM,
    payload: {
      formName
    }
  });
};
exports.destroy = destroy;
const changeSyncError = (formName, field, data) => dispatch => {
  dispatch({
    type: _FormTypes.SET_ERRORS,
    payload: {
      formName,
      field,
      data
    }
  });
};
exports.changeSyncError = changeSyncError;